import React, { useEffect, useState } from 'react';
import {
  Button,
  Column,
  DropMenu,
  DropMenuTrigger,
  Loading,
  OverlayTrigger,
  PageBar,
  PopOver,
  Select as SPAUISELECT,
  Table,
} from '@tencent/spaui';
import _ from 'lodash';
import Cookies from 'js-cookie';
import ABulkMiniDialog from '../businessSetting/ABulkMiniDialog';
import { RPCFactory } from '../../../utils/RequestUtil';

import useSelect from '../../../leads_component/shared-components/hooks/useSelect';
import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';

import FansInquire from './inquire';
import TagManageDialog from './WechatUserTagManageDialog';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import MyInput from '../../common/maxLengthInput';
import { genBasicHooks } from '../../../leads_component/shared-components/plugins/helper';
import useInput from '../../../leads_component/shared-components/hooks/useInput';
import { useInputMaxCharLengthPlugin } from '../../../leads_component/shared-components/plugins/input-plugins';

import useApp from '../../hooks/useApp';

import { badgePrefix as prefix } from '../../../consts/prefix';

const ConData = [
  {
    name: 'ctl',
    title: '',
    list: [
      {
        label: '批量修改标签',
        value: 1,
      },
      {
        label: '批量修改意向评分',
        value: 2,
      },
    ],
  },
];

const Page = (props) => {
  const [showTagManage, setShowTagManage] = useState(false);
  const [operating, setOperating] = useState(false);

  const [condition, setCondition] = useState({});
  const [tags, setTags] = useState([]);
  const [tableColumnChecks, setTableColumnChecks] = useState([]);

  const { currentApp, setApp } = useApp({ uid: window.pageProps.uid });
  const appHooks = useSelect({ data: [], value: currentApp });

  useEffect(() => {
    Cookies.set(prefix + window.pageProps.uid, 'showed');
    if (appHooks.props.value) {
      setApp(appHooks.props.value);
    }
  }, [appHooks.props.value]);

  const fansTableHooks = useTable({
    deps: [appHooks.props.value, condition],
    getList: (setTableData, setTotal, curPage, pageSize) => {
      if (appHooks.props.value !== null) {
        return RPCFactory.wechatUserManagement
          .list(appHooks.props.value, {
            wxAppId: appHooks.props.value,
            pageIndex: curPage,
            pageSize,
            ...condition,
          })
          .done((data) => {
            setTableData(data.entities);
            setTotal(data.size);
          })
          .fail((status, msg) => {
            alert(msg ? msg : '请求失败');
          });
      }
      return Promise.resolve(null);
    },
  });

  const [targetFansId, setTargetFansId] = useState();
  const [showTagEdit, setShowTagEdit] = useState(false);
  const [tagEditTarget, setTagEditTarget] = useState();
  const [selectedTags, setSelectedTags] = useState([]);

  const [showBatchDialog, setShowBatchDialog] = useState(false);
  const [showBatchScoresDialog, setShowBatchScoresDialog] = useState(false);
  const [batchSelectedTags, setBatchSelectedTags] = useState([]);
  const [selectedScores, setSelectedScores] = useState(1);
  const [region, setRegion] = useState([]);
  const [showAddTag, setShowAddTag] = useState(false);

  const nameHooks = genBasicHooks(useInput, {
    required: true,
  }).usePlugin(useInputMaxCharLengthPlugin, { maxLength: 20 });

  const subscribeScenes = [
    { label: '公众号搜索', value: 'ADD_SCENE_SEARCH' },
    { label: '公众号迁移', value: 'ADD_SCENE_ACCOUNT_MIGRATION' },
    { label: '名片分享', value: 'ADD_SCENE_PROFILE_CARD' },
    { label: '扫描二维码', value: 'ADD_SCENE_QR_CODE' },
    { label: '图文页内名称点击', value: 'ADD_SCENE_PROFILE_LINK' },
    { label: '图文页右上角菜单', value: 'ADD_SCENE_PROFILE_ITEM' },
    { label: '支付后关注', value: 'ADD_SCENE_PAID' },
    { label: '微信广告', value: 'ADD_SCENE_WECHAT_ADVERTISEMENT' },
    { label: '其他', value: 'ADD_SCENE_OTHERS' },
  ];

  const leadsIntentionTags = [
    { label: '0', value: 1 },
    { label: '0-20', value: 2 },
    { label: '20-40', value: 3 },
    { label: '40-60', value: 4 },
    { label: '60-80', value: 5 },
    { label: '80-100', value: 6 },
  ];

  const sexList = [{ label: '男', value: 1 }, { label: '女', value: 2 }];

  const subscribeStatusList = [{ label: '已关注', value: 1 }, { label: '已流失', value: 0 }];

  useEffect(() => {
    RPCFactory.fansManagement
      .verifiedList()
      .done((data) => {
        if (_.isArray(data) && data.length > 0) {
          appHooks.setData(data);
          if (currentApp == '') {
            appHooks.setValue(data[0].wxAppId);
          }
        }
      })
      .fail((status, msg) => {
        alert(msg ? msg : '请求失败');
      });
  }, []);

  const [reloadTags, setReloadTags] = useState(0);
  useEffect(() => {
    if (appHooks.props.value != null && appHooks.props.value != '') {
      RPCFactory.wechatTagManagement
        .userTagList(appHooks.props.value, {})
        .done((data) => {
          setTags(data.entities);
        })
        .fail((status, msg) => {
          alert(msg ? msg : '请求失败');
        });
    }
  }, [appHooks.props.value, reloadTags]);

  useEffect(() => {
    RPCFactory.wechatUserManagement.getRegionList().done((data) => {
      setRegion(data);
    });
  }, []);

  const doQuery = (queryCondition) => {
    setCondition(queryCondition);
    // fansTableHooks.reloadTable()
  };

  const renderUserInfo = (type, name, value, row) => {
    if (type == 'data') {
      return (
        <div className="user" style={{ 'white-space': 'nowrap' }}>
          <img src={row.headImgUrl} alt="" />
          <div className="nameinfo">
            {row.nickName}
            {/* <p className="num">微信号:{row.openId}</p>*/}
          </div>
        </div>
      );
    }
    return value;
  };

  const renderTags = (type, name, value, row) => {
    if (type == 'data') {
      const tagDesc = [];
      if (_.isArray(value)) {
        value.sort((a, b) => a - b);
        value.forEach((tagId) => {
          const index = tags.findIndex((ele) => ele.tagId === tagId);
          tagDesc.push(index >= 0 ? tags[index].tagName : tagId);
        });
      }
      const showText = tagDesc.join(', ');
      return (
        <div className="editable">
          {tagDesc.length == 0 ? <span className="c-week">暂无标签</span> : <span title={showText}>{showText}</span>}
          {row.subscribeStatus == 0 ? null : (
            <a
              aria-label="编辑"
              className="editable-icon"
              onClick={(event) => {
                setTargetFansId(row.fansId);
                setSelectedTags(value);
                setTagEditTarget(event.target);
                setShowTagEdit(true);
              }}
            >
              <i className="icon icon-pen" />
            </a>
          )}
        </div>
      );
    }
    return value;
  };

  const renderCampaign = (type, name, value, row) => {
    if (type == 'head') {
      return value;
    }

    let completeValue;
    if (!value || value == '0') {
      completeValue = '';
    } else {
      completeValue = row.campaignName ? row.campaignName.concat('(', value, ')') : value;
    }

    let showText;
    if (completeValue && completeValue.length > 15) {
      showText = `${completeValue.substr(0, 15)}...`;
    } else {
      showText = completeValue;
    }
    return <div title={completeValue}>{showText}</div>;
  };

  const renderAd = (type, name, value, row) => {
    if (type == 'head') {
      return value;
    }

    let completeValue;
    if (!value || value == '0') {
      completeValue = '';
    } else {
      completeValue = row.adName ? row.adName.concat('(', value, ')') : value;
    }

    let showText;
    if (completeValue && completeValue.length > 15) {
      showText = `${completeValue.substr(0, 15)}...`;
    } else {
      showText = completeValue;
    }
    return <div title={completeValue}>{showText}</div>;
  };

  const renderPosition = (type, name, value, row) => {
    if (type == 'head') {
      return value;
    }

    let completeValue;
    if (!value || value == '0') {
      completeValue = '';
    } else {
      completeValue = row.positionName ? row.positionName.concat('(', value, ')') : value;
    }

    let showText;
    if (completeValue && completeValue.length > 15) {
      showText = `${completeValue.substr(0, 15)}...`;
    } else {
      showText = completeValue;
    }
    return <div title={completeValue}>{showText}</div>;
  };

  const renderLocation = (type, name, value, row) => {
    let displayValue = '';
    if (type == 'data') {
      if (row.country && row.country != '') {
        displayValue = row.country;
      }
      if (row.province && row.province != '') {
        displayValue += `-${row.province}`;
      }
      if (row.city && row.city != '') {
        displayValue += `-${row.city}`;
      }
      return displayValue;
    }
    return value;
  };

  const renderDisplayValue = (type, name, value, row) => {
    if (type == 'data') {
      let list = [];
      if (name == 'sex') {
        list = sexList;
      } else if (name == 'intentionScore') {
        list = leadsIntentionTags;
      } else if (name == 'subscribeScene') {
        list = subscribeScenes;
      } else if (name == 'subscribeStatus') {
        list = subscribeStatusList;
      }
      for (const val of list) {
        if (value != null && value == val.value) {
          return val.label;
        }
      }
    } else {
      return value;
    }
  };

  const onTableOptionalChange = (event, value) => {
    setTableColumnChecks(value);
  };

  const renderTable = () => (
    <Table data={fansTableHooks.data} loading={fansTableHooks.tableLoading}>
      {/* onColumnWidthChange={this.handleColumnWidthChange}*/}
      <Column
        fixedable
        type="optional"
        target="fansId"
        multiple
        onOptionalChange={onTableOptionalChange}
        value={tableColumnChecks}
        canOptional={(row, disabled) => row.subscribeStatus !== 0}
      ></Column>
      <Column name="name" fixedable adjustWidth render={renderUserInfo}>
        用户信息
      </Column>
      <Column name="sex" fixedable render={renderDisplayValue}>
        性别
      </Column>
      <Column name="location" fixedable adjustWidth render={renderLocation}>
        国家-省份-城市
      </Column>
      <Column name="tagIds" render={renderTags} maxWidth={250}>
        标签
      </Column>
      <Column name="intentionScore" render={renderDisplayValue} minWidth={80}>
        意向评分
      </Column>
      <Column name="subscribeScene" render={renderDisplayValue} minWidth={80}>
        渠道来源
      </Column>
      <Column name="campaignId" render={renderCampaign} minWidth={150}>
        推广计划
      </Column>
      <Column name="adId" render={renderAd} minWidth={150}>
        广告
      </Column>
      <Column name="positionId" render={renderPosition} minWidth={150}>
        广告位
      </Column>
      <Column name="subscribeStatus" render={renderDisplayValue} minWidth={60}>
        状态
      </Column>
      <Column name="subscribeTime" minWidth={150}>
        关注时间
      </Column>
      <Column name="unsubscribeTime" minWidth={150}>
        取关时间
      </Column>
      {/* <Column name='operate' adjustWidth >操作</Column>*/}
    </Table>
  );
  const showBatchOperateDialog = (e, data) => {
    if (tableColumnChecks.length == 0) {
      window.alert('请选择需要操作的粉丝');
      return;
    }
    if (data.ctl === 1) {
      const canDistribute = window.pageProps.privileges.includes(PrivilegeCode.WX_APP_FANS_MANAGE.getCode());
      if (canDistribute) {
        setShowBatchDialog(true);
      } else {
        window.alert('您无权限进行修改！');
      }
    } else if (data.ctl === 2) {
      const canDistribute = window.pageProps.privileges.includes(PrivilegeCode.WX_APP_FANS_MANAGE.getCode());
      if (canDistribute) {
        setShowBatchScoresDialog(true);
      } else {
        window.alert('您无权限进行修改！');
      }
    }
  };

  const updateFansTag = () => {
    if (selectedTags.length > 20) {
      alert('最多选择20个标签');
      return;
    }
    setOperating(true);
    RPCFactory.wechatUserManagement
      .updateTags(appHooks.props.value, { fansIds: [targetFansId], tagIds: selectedTags })
      .done((data) => {
        setShowTagEdit(false);
        fansTableHooks.reloadTable();
      })
      .fail((status, msg) => {
        alert(msg ? msg : '请求失败');
      })
      .always(() => {
        setOperating(false);
      });
  };

  const batchEditTags = () => {
    if (batchSelectedTags.length > 20) {
      setShowBatchDialog(false);
      alert('最多选择20个标签');
      return;
    }
    setOperating(true);
    RPCFactory.wechatUserManagement
      .updateTags(appHooks.props.value, {
        fansIds: tableColumnChecks,
        tagIds: batchSelectedTags,
      })
      .done((data) => {
        setShowBatchDialog(false);
        fansTableHooks.reloadTable();
      })
      .fail((status, msg) => {
        setShowBatchDialog(false);
        alert(msg ? msg : '请求失败');
      })
      .always(() => {
        setOperating(false);
      });
  };

  const batchEditScores = () => {
    setShowBatchScoresDialog(true);
    RPCFactory.wechatUserManagement
      .updateScores(appHooks.props.value, {
        fansIds: tableColumnChecks,
        intentionScore: selectedScores,
      })
      .done((data) => {
        setShowBatchScoresDialog(false);
        fansTableHooks.reloadTable();
      })
      .fail((status, msg) => {
        setShowBatchScoresDialog(false);
        alert(msg ? msg : '请求失败');
      })
      .always(() => {
        setShowBatchScoresDialog(false);
      });
  };

  const renderDataToolBar = () => (
    <div className="toolbars">
      <div className="toolbar table-toolbar">
        <div className="toolbar-left">
          <h4>粉丝信息</h4>
        </div>
        <div className="toolbar-right">
          <div className="toolbar-right-inner">
            <div className="toolbar-right-group">
              {/* 批量操作二级菜单 */}
              {window.pageProps.privileges.includes(PrivilegeCode.WX_APP_FANS_MANAGE.getCode()) ? (
                <DropMenuTrigger dropMenu={<DropMenu data={ConData} onChange={showBatchOperateDialog} />}>
                  <Button className="borderless">
                    <i className="icon icon-batch"></i>批量操作
                  </Button>
                </DropMenuTrigger>
              ) : null}

              <Button className="borderless">
                <i className="icon icon-tag"></i>
                <span
                  className="spaui-text"
                  onClick={() => {
                    if (appHooks.props.value == '') {
                      alert('请先选择公众号');
                    } else {
                      setShowTagManage(true);
                    }
                  }}
                >
                  标签管理
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const createTag = () => {
    if (!nameHooks.checkValid()) {
      return;
    }
    setOperating(true);
    RPCFactory.wechatTagManagement
      .add(appHooks.props.value, nameHooks.value)
      .done((data) => {
        setReloadTags(reloadTags + 1);
        setShowAddTag(false);
      })
      .fail((code, msg) => {
        alert(msg);
      })
      .always(() => {
        setOperating(false);
      });
  };

  return (
    <main className="main" id="main">
      <div className="page-pool">
        <div className="a-tabs-head-right" style={{ top: '-55px' }}>
          <div className="timely-tips">
            <span style={{ display: 'block', padding: '2px 4px 0 0' }}>所属公众号</span>
            <SPAUISELECT valueFieldName="wxAppId" labelFieldName="nickName" {...appHooks.props} />
          </div>
        </div>
      </div>
      <div className="card padding-normal" id="inquire">
        <FansInquire
          wxAppId={appHooks.props.value}
          subscribeScenes={subscribeScenes}
          leadsIntentionTags={leadsIntentionTags}
          sexList={sexList}
          tags={tags}
          subscribeStatusList={subscribeStatusList}
          onSubmit={doQuery}
          region={region}
        ></FansInquire>
      </div>
      <div className="card">
        <div className="datarea">
          {renderDataToolBar()}
          <div className="datalist">{renderTable()}</div>
          <PageBar {...fansTableHooks.pageBarAttr} />
        </div>
      </div>
      {showTagManage && (
        <TagManageDialog
          wxAppId={appHooks.props.value}
          handleClose={() => {
            setShowTagManage(false);
            setReloadTags(reloadTags + 1);
          }}
        />
      )}
      <ABulkMiniDialog
        title={''}
        show={showTagEdit}
        eventTarget={tagEditTarget}
        onSubmit={() => {
          updateFansTag();
        }}
        onCancel={() => {
          setShowTagEdit(false);
        }}
        width={'420px'}
        eventTargetPlacement={'auto'}
      >
        <div className="tagrule-new">
          <ul className="tags-lump clearfix">
            {tags.map((tag, index) => (
              <li
                key={index}
                className={`tags${selectedTags.includes(tag.tagId) ? ' selected' : ''}`}
                onClick={() => {
                  let hasSelected = false;
                  const newSelectedTags = selectedTags.filter((item) => {
                    if (item === tag.tagId) {
                      hasSelected = true;
                    }
                    return item !== tag.tagId;
                  });
                  if (!hasSelected) {
                    newSelectedTags.push(tag.tagId);
                  }
                  setSelectedTags(newSelectedTags);
                }}
              >
                <div className="inner">{tag.tagName}</div>
              </li>
            ))}
            <li className="tags">
              <div className="inner">
                <OverlayTrigger
                  trigger="click"
                  show={showAddTag}
                  documentClickAutoHide="false"
                  onShowChange={(event, show) => {
                    if (show) {
                      nameHooks.setValue('');
                    }
                  }}
                  overlay={
                    <PopOver className="with-btns">
                      <div className="spaui-popover-body">
                        <MyInput placeholder="输入标签名称" {...nameHooks.props} />
                      </div>
                      <div className="spaui-popover-btns">
                        <a
                          className="btn btn-default"
                          onClick={() => {
                            setShowAddTag(false);
                          }}
                        >
                          取消
                        </a>
                        <a
                          className="btn btn-primary"
                          onClick={() => {
                            createTag();
                          }}
                        >
                          确定
                        </a>
                      </div>
                    </PopOver>
                  }
                >
                  <a
                    onClick={() => {
                      setShowAddTag(true);
                    }}
                  >
                    + 新建标签
                  </a>
                </OverlayTrigger>
              </div>
            </li>
          </ul>
        </div>
      </ABulkMiniDialog>
      {showBatchDialog ? (
        <ABulkMiniDialog
          title={'批量修改标签'}
          onSubmit={() => {
            batchEditTags();
          }}
          onCancel={() => {
            setShowBatchDialog(false);
            setBatchSelectedTags([]);
          }}
          onclose={() => {
            setShowBatchDialog(false);
            setBatchSelectedTags([]);
          }}
          width={'420px'}
          eventTargetPlacement={'auto'}
        >
          <SPAUISELECT
            multiple
            max={20}
            placeholder="请选择"
            data={tags}
            valueFieldName="tagId"
            labelFieldName="tagName"
            value={batchSelectedTags}
            onChange={(e, value) => {
              setBatchSelectedTags(value);
            }}
          />
        </ABulkMiniDialog>
      ) : null}
      {showBatchScoresDialog ? (
        <ABulkMiniDialog
          title={'批量修改意向评分'}
          onSubmit={() => {
            batchEditScores();
          }}
          onCancel={() => {
            setShowBatchScoresDialog(false);
          }}
          onclose={() => {
            setShowBatchScoresDialog(false);
          }}
          width={'420px'}
          eventTargetPlacement={'auto'}
        >
          <SPAUISELECT
            placeholder="请选择"
            data={leadsIntentionTags}
            // valueFieldName="tagId"
            // labelFieldName="tagName"
            value={selectedScores}
            onChange={(e, value) => {
              setSelectedScores(value);
            }}
          />
        </ABulkMiniDialog>
      ) : null}
      <Loading show={operating} type="page" />
    </main>
  );
};

export default Page;
